import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "314",
  "slug": "spot-nigeria-from-satellite-imagery",
  "title": "How to Recognise Nigeria in Satellite Images",
  "excerpt": "The Niger Delta is a useful coastal anchor, with distributary channels entering the Gulf of Guinea.",
  "date": "2026-05-09",
  "category": "Geography",
  "image": "/blog-images/nigeria.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The Niger Delta is a useful coastal anchor, with distributary channels entering the Gulf of Guinea. Inland, the Niger and Benue meet at Lokoja. Finding that confluence gives you a relationship between two rivers that is more specific than a broad band of green vegetation."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Trace the coast west toward the Lagos lagoon system, then compare the delta with the inland river network. Wetlands and dense settlement also occur elsewhere in West Africa. Neither a large city nor an apparent gas flare establishes a country by itself, and ordinary daytime imagery cannot support claims about night-time lighting."
    }
  ],
  "imageAlt": "Nigeria regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
